import React, { useState, useMemo } from "react";


// const PropertyList = ({ parcels = [] }) => {
const PropertyList = ({ parcels = [], onRowClick }) => {


    const [sortKey, setSortKey] = useState(null); // "totalunits" or "totallandvalue"
    const [sortDir, setSortDir] = useState("asc"); // "asc" or "desc"
    const [selectedRow, setSelectedRow] = useState(null);

    const toggleSort = (key) => {
        if (sortKey === key) {
            setSortDir((d) => (d === "asc" ? "desc" : "asc"));
        } else {
            setSortKey(key);
            setSortDir("asc");
        }
    };

    const parseNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        const n = Number(String(v).replace(/[^0-9.-]/g, ""));
        return Number.isFinite(n) ? n : NaN;
    };

    // Normalize incoming parcels (if GeoJSON features, use .properties)
    const normalizedItems = useMemo(() => {
        if (!Array.isArray(parcels)) return [];
        return parcels.map((it) => {
            if (!it) return {};
            if (it.properties && typeof it.properties === "object") return { ...it.properties, __feature__: it };
            return { ...it };
        });
    }, [parcels]);

    // Sorting implementation that pushes non-numeric values to the end
    const sortedParcels = useMemo(() => {
        if (!normalizedItems || normalizedItems.length === 0) return [];
        if (!sortKey) return normalizedItems;

        const getKeyVal = (item) => {
            if (sortKey === "totalunits") {
                return parseNumber(item.totalunits ?? item.total_units ?? item.units ?? item.Unit);
            }
            if (sortKey === "totallandvalue") {
                return parseNumber(
                    item.totallandvalue ??
                    item.total_land_value ??
                    item.totallandvalue_usd ??
                    item.totallandvalue ??
                    item.landvalue ??
                    item.land_value ??
                    item.totalvalue ??
                    item.total_value
                );
            }
                       // ✅ NEW: Spread % sorting
            if (sortKey === "spreadpercentage") {
                return parseNumber(
                    item.spreadpercentage ??
                    item.spreadPercent ??
                    item.spread_percentage ??
                    item.spread_percent
                );
            }
            return NaN;
        };

        const cmp = (a, b) => {
            const na = getKeyVal(a);
            const nb = getKeyVal(b);
            const aValid = Number.isFinite(na);
            const bValid = Number.isFinite(nb);
            if (!aValid && !bValid) return 0;
            if (!aValid) return 1; // push invalid (N/A) to end
            if (!bValid) return -1;
            return na < nb ? -1 : na > nb ? 1 : 0;
        };

        const arr = [...normalizedItems].sort((a, b) => {
            const r = cmp(a, b);
            return sortDir === "asc" ? r : -r;
        });
        return arr;
    }, [normalizedItems, sortKey, sortDir]);

    const handleRowClick1 = (item, index) => {
        setSelectedRow(index); // Highlight selected row

        if (onRowClick && typeof onRowClick === "function") {
            // Pass the full property object to parent
            onRowClick(item);
        }
    };
    const handleRowClick = (item, index) => {
    setSelectedRow(index); // Highlight selected row

    console.log("Row clicked:", item); // ✅ ADD: Debug log
    console.log("Coordinates:", item.latitude, item.longitude); // ✅ ADD: Check coords

    if (onRowClick && typeof onRowClick === "function") {
        // Pass the full property object to parent
        onRowClick(item);
    } else {
        console.warn("onRowClick is not a function or not provided"); // ✅ ADD: Warning
    }
};

    return (
        <div
            className="listOuter"
            style={{
                width: "100%",
                height: "114%",
            }}
        >
            <div

                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "85%",
                }}
            >
                {/* Header */}
                <div style={{ flex: 1, overflowY: "auto", height: "100%" }}  >
                    {parcels.length === 0 ? (
                        <div style={{ padding: "10px", textAlign: "center", color: "#777" }}>
                            No Records Found
                        </div>
                    ) : (
                        // <table className="property-table">
                        <table
                            className="property-table"
                            style={{
                                tableLayout: "auto", // let columns size naturally
                                width: "100%", minWidth: "1200px", // ensure table can overflow to show horizontal scroll
                                borderCollapse: "collapse",
                            }}
                        >
                            <thead>
                                <tr
                                    style={{
                                        background: "#e0e0e0",
                                        fontWeight: "bold",
                                        borderBottom: "1px solid #ccc",
                                    }}
                                >
                                    <th style={{ textAlign: "left", padding: "8px" }}>Parcel</th>
      {/* <th style={{ 
        textAlign: "left", 
        padding: "8px 12px", 
        whiteSpace: "nowrap",
        width: "auto",        
      }}>
        Parcel
      </th> */}

                                    <th style={{ textAlign: "right", padding: "8px" }}>Size</th>
                                    <th style={{ textAlign: "right", padding: "8px" }}>Zoning</th>

                                    {/* <th style={{ textAlign: "right", padding: "8px" }}>sqft Price</th> */}
                                    <th style={{ textAlign: "right", padding: "8px" }}>Target ARV</th>
                                    <th style={{ textAlign: "right", padding: "8px" }}>Land Value/Unit</th>

                                    <th
                                        style={{
                                            textAlign: "right",
                                            padding: "8px",
                                            cursor: "pointer",
                                            userSelect: "none",

                                            alignItems: "center",
                                            gap: 6,
                                        }}
                                        onClick={() => toggleSort("totalunits")}
                                    >
                                       Max Unit
                                        <span style={{ fontSize: 11 }}>{sortKey === "totalunits" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}</span>
                                    </th>
                                    <th
                                        style={{
                                            textAlign: "right",
                                            padding: "8px",
                                            cursor: "pointer",
                                            userSelect: "none",

                                            alignItems: "center",
                                            gap: 6,
                                        }}
                                        onClick={() => toggleSort("totallandvalue")}
                                    >
                                        {/* Total Land Value */}
                                        Developed Value
                                        <span style={{ fontSize: 11 }}>{sortKey === "totallandvalue" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}</span>
                                    </th>
                                    <th style={{ textAlign: "right", padding: "8px" }}>Price</th>
                                    <th style={{ textAlign: "right", padding: "8px" }}>Spread</th>
                                    {/* <th style={{ textAlign: "right", padding: "8px" }}>Spread %</th> */}
                                              <th
                                        style={{
                                            textAlign: "right",
                                            padding: "8px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            alignItems: "center",
                                            gap: 6,
                                        }}
                                        onClick={() => toggleSort("spreadpercentage")}
                                    >
                                        Spread %
                                        <span style={{ fontSize: 11 }}>
                                            {sortKey === "spreadpercentage" ? (sortDir === "asc" ? "▲" : "▼") : "↕"}
                                        </span>
                                    </th>
                                    {/* <th style={{ textAlign: "left", padding: "8px" }}>zonedcodelocal</th> */}

                                    {/* <th style={{ textAlign: "left", padding: "8px", maxWidth: "140px" }}>Listed Sale</th> */}
                                </tr>
                            </thead>

                            <tbody>
                                {sortedParcels.map((item, i) => {
                                    const p = item || {};
                                    const isSelected = selectedRow === i;
                                    return (
                                        <tr key={i}
                                            onClick={() => handleRowClick(p, i)}
                                            // style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9", borderBottom: "1px solid #f0f0f0" }}
                                            style={{
                                                background: isSelected
                                                    ? "#dcedeb" // ✅ Highlight selected row
                                                    : i % 2 === 0
                                                        ? "#fff"
                                                        : "#f9f9f9",
                                                borderBottom: "1px solid #f0f0f0",
                                                cursor: "pointer", // ✅ Show clickable cursor
                                                transition: "background 0.2s ease", // ✅ Smooth transition
                                            }}
                                            onMouseEnter={(e) => {
                                                // ✅ Hover effect
                                                if (!isSelected) {
                                                    e.currentTarget.style.background = "#f5f5f5";
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                // ✅ Remove hover effect
                                                if (!isSelected) {
                                                    e.currentTarget.style.background =
                                                        i % 2 === 0 ? "#fff" : "#f9f9f9";
                                                }
                                            }}
                                        >

                                            <td style={{ padding: "8px" }}>{p.parcel || "N/A"}</td>
          {/* <td style={{ 
            padding: "8px 12px",      
            overflow: "hidden",       
            textOverflow: "ellipsis",
            maxWidth: "200px",       
          }}>
            {p.parcel || "N/A"}
          </td> */}
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.parcelsize ? p.parcelsize.toFixed(3) : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>{p.zonedcodelocal || "N/A"}</td>

                                            {/* <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.sqftrate ? `${p.sqftrate.toLocaleString()}` : "N/A"}
                                            </td> */}
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.targetarv ? `$${p.targetarv.toLocaleString()}` : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.landvalueperunit ? `$${p.landvalueperunit.toLocaleString()}` : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.totalunits ? `${p.totalunits.toLocaleString()}` : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.totallandvalue ? `$${p.totallandvalue.toLocaleString()}` : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.zestimate ? `$${p.zestimate.toLocaleString()}` : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.spread ? `$${p.spread.toLocaleString()}` : "N/A"}
                                            </td>
                                            <td style={{ textAlign: "right", padding: "8px" }}>
                                                {p.spread ? `${Number(p.spreadpercentage ?? p.spreadPercent ?? 0)}%` : "N/A"}
                                            </td>
                                            {/* <td style={{ textAlign: "left", padding: "8px" }}>
                                                {p.zonedcodelocal ? `${p.zonedcodelocal.toLocaleString()}` : "N/A"}
                                            </td> */}
                                        </tr>
                                    );
                                })}


                            </tbody>
                        </table>

                    )}
                </div>
            </div>
        </div>
    );
};

export default PropertyList;

